import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
    datePicker: {
        width: '100%',
        marginBottom: '20px',
    },
    pickerBody: {
        '& .MuiTypography-body2': {
            fontWeight: 400,
        },
    },
}));
